"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SYPreloadScene = void 0;
const SYSceneNames_1 = require("./SYSceneNames");
const KHPreloadScene_1 = require("./KH/KHPreloadScene");
class SYPreloadScene extends KHPreloadScene_1.KHPreloadScene {
    constructor() {
        super(SYSceneNames_1.default.Preload);
    }
    nextScene() {
        return SYSceneNames_1.default.Menu;
    }
    palette() {
        return [0xFFFFFF, 0x0, 0xFFFFFF];
    }
    loadAssets() {
        super.loadAssets();
        // rexinputtextplugin.min.js
        this.load.image('logo', 'assets/logo.png');
        this.load.bitmapFont('font', 'assets/RMono_0.png', 'assets/RMono.fnt');
    }
}
exports.SYPreloadScene = SYPreloadScene;
